export const ShipmentMethodType = ["Air", "Ocean", "Land", "OceanAndAir"];

export const handleNumericInput = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const regex = new RegExp(/(^\d*$)|(Backspace|Tab|Delete|ArrowLeft|ArrowRight|\.)/);
    if (!event.key.match(regex)) {
        event.preventDefault();
    }
};
